module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-buttons"
  }, [(!_vm.isJoined) ? [_c('div', {
    staticClass: "card-btn__copy"
  }, [_vm._v("\n            Not a member yet?\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-btn__copy"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.onActivate()
      }
    }
  }, [_vm._v("Join")])], 1)] : (_vm.isLinked) ? [_c('div', {
    staticClass: "membership"
  }, [
    [_vm._v("\n                SK Club card number\n                "), _c('div', {
      staticClass: "membership-number"
    }, [_vm._v("\n                    " + _vm._s(_vm.CardNumber) + "\n                ")])], _vm._v(" "), (_vm.CardNumber != null) ? [(!_vm.showConfirmReplaceCard) ? _c('sk-button', {
      attrs: {
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.showConfirmReplaceCard = true
        }
      }
    }, [_vm._v("Replace Card")]) : _vm._e(), _vm._v(" "), (_vm.showConfirmReplaceCard) ? _c('div', [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Replace Card")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.CardNumber))]), _vm._v(" "), _c('p', [_vm._v("By replacing this card number your old card number will no longer work and you will receive an email with a new card number.")]), _vm._v(" "), _c('p', [_vm._v("Are you sure you want to replace your card number now?")]), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('sk-button', {
      attrs: {
        "secondary": "",
        "close": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.showConfirmReplaceCard = false;
        }
      }
    }, [_vm._v("\n                                Wait, take me back.\n                            ")])], 1)], 1), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('sk-button', {
      attrs: {
        "primary": "",
        "close": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.showConfirmReplaceCard = false;
          _vm.replaceCard(_vm.CardNumber);
        }
      }
    }, [_vm._v("\n                                Yes. I'm sure.\n                            ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showReplaceCardError) ? _c('div', [_c('p', [_vm._v("Your card number could not be replaced at the moment. Please try again later.")])]) : _vm._e()] : _vm._e()
  ], 2)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fa7dd58","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/card/card-sk-club.vue
// module id = 917
// module chunks = 0